import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';
import { Svg } from "./Svg";
import { useDispatch } from "react-redux";
import { setTopLevelOpen } from "../Actions/Navigation.action";

const NavigationItem = ({ links = [], contentLink = null, isMainNav, topLevelOpen }) => {
    const isMainTopLevel = !contentLink && isMainNav && typeof topLevelOpen !== 'undefined';
    const dispatch = useDispatch();
    const menuRef = useRef(null);
    const toggleMenu = (e) => {
        e.preventDefault();

        if (isMainTopLevel) {
            dispatch(setTopLevelOpen(!topLevelOpen));
        }

        menuRef.current.classList.toggle('navbar__menu--show');
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;

    const onMouseOver = (link) => {
        let hasChildren = link.links.length > 0;
        if (isMainTopLevel && hasChildren && window.outerWidth >= 1024) {
            dispatch(setTopLevelOpen(true));
        }
    };

    const onMouseOut = (link) => {
        let hasChildren = link.links.length > 0;
        if (isMainTopLevel && hasChildren && window.outerWidth >= 1024) {
            dispatch(setTopLevelOpen(false));
        }
    };
    const hasNameOrChildren = (link) => link.name || (link.links || []).length > 0;
    const navigationIcon = (contentLink) => {
        if (contentLink.nestingLevel !== 1) return null;
        return contentLink.iconName && <div className='navbar__cat-icon-wrapper'><Svg icon={contentLink.iconName} extraClass='navbar__cat-icon' color='ocean' /></div>;
    }

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                ><Svg icon="menu" /><div className="navbar__menu_title">{translate('nmas.navigation.mobile.title')}</div></a>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${
                            hasChildrenClass || ''
                        } ${additionClass || ''}`}
                        href={contentLink.url || '#'}
                    >{navigationIcon(contentLink)} <span>{contentLink.name}</span> {hasChildrenClass && <Svg icon='chevron' extraClass={'child-indicator'}/>}</a>
                    {contentLink.links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ><Svg icon="chevron" extraClass="chevron-down" /></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <div className={`navbar__menu ${(topLevelOpen && isMainTopLevel ? 'navbar__menu--show' : '')} level-${links[0].nestingLevel}`} ref={menuRef}>
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <>
                                <span>&nbsp;</span>
                                <span
                                    className="navbar__icon navbar__icon--close"
                                    onClick={toggleMenu}
                                ><Svg icon="close" /></span>
                            </>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ><Svg icon="chevron" extraClass="chevron-left" /></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>
                    <ul className="navbar__menu-links">
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className={`navbar__item level-${link.nestingLevel}`}
                                            key={index}
                                            onMouseOver={() => onMouseOver(link)}
                                            onMouseOut={() => onMouseOut(link)}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                                topLevelOpen={topLevelOpen}
                                            />
                                        </li>
                                    )
                            )}
                    </ul>
                </div>
            )}
        </Fragment>
    );
};

export default NavigationItem;
